import thunk from 'redux-thunk';
import { reducer } from 'redux-form';
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import config from './../config/config.js';
import auth from './auth';
import common from './common';
import style from './style';
import infoadd from './infoadd';
import infoupd from './infoupd';
import infoaddSelect from './infoaddSelect';

export const history = createBrowserHistory();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const logger = createLogger({
  diff: true,
  collapsed: true,
});
const appReducer = combineReducers({
  auth,
  common,
  style,
  infoadd,
  infoupd,
  infoaddSelect,
  router: connectRouter(history),
  form: reducer,
});

const rootReducer = (state, action) => {
  if(action.type === "STORE_INIT"){
    var preserveState = {};
    preserveState.style = state.style;
    return appReducer(preserveState, action);
  }
  return appReducer(state, action);
};

//永続化
const persistConfig = {
  key: 'reactRoot',
  storage,
  //whitelist: ['xxx'],
  //blacklist: ['xxx'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleWare = (config.reduxLogFlag) ?
  applyMiddleware(thunk, logger, routerMiddleware(history))
  :
  applyMiddleware(thunk, routerMiddleware(history));

export function persistor(store) {
  return  persistStore(store);
}

export default function configureStore(initialState = {}) {
  return createStore(
    persistedReducer,
    initialState,
    composeEnhancers(middleWare),
  );
}